import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'mapfre-notification-3',
  templateUrl: './notification-3.component.html',
  styleUrls: ['./notification-3.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Notification3Component {
  @Input() text = 'FORWARDED_CODE';
}
